import { createFileRoute } from "@tanstack/react-router";
import DonationTypeSelect from "@project/donate/pages/items/index";

export const Route = createFileRoute("/donate/items")({
  head: () => ({ meta: [{ title: "Donate Items — Jivandhara" }] }),
  component: DonationTypeSelect,
});
